import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useT } from "@/content/landing";
import { Reveal } from "./Reveal";
export function Faq() {
  const t = useT();
  const [open, setOpen] = useState(0);
  return <section id="faq" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <Reveal>
          <h2 className="text-2xl font-bold text-[#0F172A] sm:text-3xl">{t.faq.title}</h2>
        </Reveal>
        <dl className="mt-10 divide-y divide-black/5 border-y border-black/5">
          {t.faq.items.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.q}>
                <dt>
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} id={`faq-button-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:ring-2 focus-visible:ring-[#3B82F6] focus-visible:outline-none">
                    <span className="text-base font-semibold text-[#0F172A]">{item.q}</span>
                    <ChevronDown size={18} aria-hidden className={`shrink-0 transition-transform duration-300 motion-reduce:transition-none ${isOpen ? "rotate-180" : ""}`} style={{
                  color: "#94A3B8"
                }} />
                  </button>
                </dt>
                <dd id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} hidden={!isOpen} className="pb-5 text-sm leading-relaxed text-[#64748B]">
                  {item.a}
                </dd>
              </div>;
        })}
        </dl>
      </div>
    </section>;
}